import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import PerdM from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import GeolocationButton from "components/form/input/GeolocationButton";
import { useCoordinates } from "util/geolocation";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Insumo from "entity/Insumo";
import { useForm } from "react-final-form";
import Operador from "entity/Operador";

export default function PerdMEditFields({ visita, isNew, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(PerdM, "Manual", TipoClass), [visita.cliente]);
    const [apontamento, setApontamento] = useFieldValue();
    const [coordinates] = useCoordinates();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Manual") {
            setTipo("Manual");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = PerdM.calcConformidade(apontamento, params, setApontamento);
            form.change("toco", apontamento.toco);
            form.change("ponteiro", apontamento.ponteiro);
            form.change("canaFixa", apontamento.canaFixa);
            form.change("estilhaco", apontamento.estilhaco);
            form.change("tolete", apontamento.tolete);
            form.change("pedaco", apontamento.pedaco);

            if (isNew && !apontamento.georeferencia) {
                apontamento.georeferencia = coordinates;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, coordinates, isNew, params]);

    return (
        <>
            <ApontamentoCommonFields
                visita={visita}
                showTrator={false}
                showImplemento={false}
                showEquipamento={true}
                showVariedade
                showCorte
            />

            <ApontamentoAmostraParams tipoFixedValue="Manual">
                <FormRow>
                    <EntitySearchInput name="insumo" label="Variedade" EntityClass={Insumo} />
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="tch" label="TCH" />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                        {params.tamanhoPonto && (
                            <ApontamentoParamItem label="Tamanho do Ponto:">{params.tamanhoPonto}</ApontamentoParamItem>
                        )}
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita} showList={false}>
                {params && params.toco && (
                    <FormRow>
                        <TextInput type="number" name="toco" label="Toco (g)" initialValue={apontamento?.toco || 0} />
                    </FormRow>
                )}
                {params && params.ponteiro && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="ponteiro"
                            label="Ponteiro (g)"
                            initialValue={apontamento?.ponteiro || 0}
                        />
                    </FormRow>
                )}
                {params && params.canaInteira && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="canaInteira"
                            label="Cana Inteira (g)"
                            initialValue={apontamento?.canaInteira || 0}
                        />
                    </FormRow>
                )}
                {params && params.canaFixa && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="canaFixa"
                            label="Cana/Pedaço Fixo (g)"
                            initialValue={apontamento?.canaFixa || 0}
                        />
                    </FormRow>
                )}
                {params && params.estilhaco && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="estilhaco"
                            label="Estilhaço (g)"
                            initialValue={apontamento?.estilhaco || 0}
                        />
                    </FormRow>
                )}
                {params && params.tolete && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="tolete"
                            label="Tolete (g)"
                            initialValue={apontamento?.tolete || 0}
                        />
                    </FormRow>
                )}
                {params && params.pedaco && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="pedaco"
                            label="Pedaço (g)"
                            initialValue={apontamento?.pedaco || 0}
                        />
                    </FormRow>
                )}
                {params && params.lasca && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="lasca"
                            label="Lasca (g)"
                            initialValue={apontamento?.lasca || 0}
                        />
                    </FormRow>
                )}
                {params && params.toleteEstilhacado && (
                    <FormRow>
                        <TextInput
                            type="number"
                            name="toleteEstilhacado"
                            label="Tolete Estilhaçado (g)"
                            initialValue={apontamento?.toleteEstilhacado || 0}
                        />
                    </FormRow>
                )}
                <FormRow>
                    <GeolocationButton name="georeferencia" />
                </FormRow>
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Perdas (%)">
                <FormRow>
                    <TextInput name="totalPerdas" label="Total Perdas (g)" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
